import React, { useCallback, useEffect, useRef, useState } from "react";
import mqtt from "mqtt";
import { Cookies } from "../../../../index.js";

export default function GoToPostVideos() {
    const code_item = Cookies.get("code_item"); // topic ID user
    const [status_videos, set_status_videos] = useState(false);

    const clientRef = useRef(null);
    const publishMessage = () => {
        if (!clientRef.current || !clientRef.current.connected) {
            console.warn("⚠️ MQTT client chưa sẵn sàng để gửi message.");
            return;
        }

        if (!code_item) {
            console.warn("⚠️ Không có code_item — không thể gửi message.");
            return;
        }

        const payload = {
            mode: "posts",
            category: "upload_videos_check",
            value: false,
        };

        clientRef.current.publish(code_item, JSON.stringify(payload));
        console.log("📤 Đã gửi message:", payload);
    };
    // ✅ Kết nối MQTT khi component mount
    useEffect(() => {
        if (!code_item) {
            console.warn("⚠️ Không có code_item trong cookie — bỏ qua MQTT.");
            return;
        }

        console.log("🧩 Khởi tạo MQTT WebSocket...");
        const client = mqtt.connect("wss://ws.hust.media", {
            will: {
                topic: "server_log",
                payload: `Client ${code_item} đã ngắt kết nối`,
                qos: 0,
                retain: false,
            },
        });

        clientRef.current = client;

        client.on("connect", () => {
            console.log("✅ MQTT WebSocket connected!");
            client.subscribe(code_item, (err) => {
                if (err) return console.error("❌ Subscribe thất bại:", err.message);
                console.log(`📡 Subscribed to topic: ${code_item}`);

                // 🔔 Gửi tin nhắn thông báo khi client kết nối
                client.publish("server_log", `Client ${code_item} đã kết nối`);
            });
        });


        client.on("message", (topic, message) => {
            const now = new Date().toLocaleTimeString();
            const text = message.toString();

            try {
                const data = JSON.parse(text);
                if (data.hasOwnProperty("upload_videos_check")) {
                    console.log(`[${now}] 📩 ${topic}: upload_videos_check = ${data.upload_videos_check}`);
                    if (data.upload_videos_check == true) {
                        set_status_videos(true);
                    }
                    Cookies.set('upload_videos_check', data.upload_videos_check, { expires: 300 });
                }
            } catch {
                // không phải JSON thì bỏ qua
            }
        });


        client.on("error", (err) => {
            console.error("⚠️ MQTT error:", err.message);
        });

        client.on("close", () => {
            console.log("🔴 MQTT WebSocket disconnected");
        });

        return () => {
            console.log("🔌 Ngắt MQTT client khi component unmount");
            publishMessage();
            setTimeout(() => client.end(true), 500);
        };
    }, []);

    // ✅ Nút gửi video (giữ nguyên logic cũ)
    const click_ok = useCallback(() => {
        const userAgent = navigator.userAgent.toLowerCase();
        const baseUrl = "https://hust.media/next_js/process/post_videos";
        const url = userAgent.includes("hustmedia-android")
            ? `${baseUrl}?app=uiviewcontroller&code_item=${code_item}`
            : `${baseUrl}?code_item=${code_item}`;
        window.location.href = url;
    }, []);

    return (

        <>
            {status_videos == false && (
                <div className="flex items-center justify-center">
                    <button
                        onClick={click_ok}
                        className="px-6 py-3 text-xl bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                    >
                        🚀 Gửi Video
                    </button>
                </div>
            )}

            {status_videos == true && (
                <div className="flex items-center justify-center">
                    <button
                        disabled
                        className="px- py-2 text-xl bg-gray-400 text-white rounded-lg cursor-not-allowed"
                    >
                        ✅ Gửi video thành công
                    </button>
                </div>
            )}

        </>

    );
}
